<template>
  <div class="common-page commission-sharing-rule-config">
    <div class="left-box">
      <div class="left-content">
        <div
          class="list"
          v-for="(item, index) in dispatchDeptData"
          :key="index"
          :class="
            searchForm.shareStageId === item.shareStageId
              ? 'select-dispatch'
              : ''
          "
          @click="checkDispatch(item)"
        >
          <span v-if="item.right">{{ item.left }}-{{ item.right }}(含)</span>
          <span v-else>{{ item.left }}以上</span>
        </div>
      </div>
    </div>
    <div class="right-box" v-loading="loading">
      <div class="right-content">
        <div class="config-list">
          <div class="config-list-title">
            <div class="config-list-title-txt">
              <span>平台订单分佣规则设置</span>
              <span
                >平台订单分佣规则按平台订单金额（不含发票金额）进行比例分成计算</span
              >
            </div>
          </div>
          <el-row :gutter="10" class="form-box1">
            <el-form
              ref="form1"
              :model="form"
              :rules="rules"
              label-position="top"
            >
              <el-col :span="24" class="form-box-item-title">
                <el-col :span="4">
                  <span>机构名称</span>
                </el-col>
                <el-col :span="4"><span class="dot">拼满运抽成</span></el-col>
                <el-col :span="4"
                  ><span class="dot">平台技术服务费</span></el-col
                >
                <el-col :span="4"><span class="dot">订金</span></el-col>
                <el-col :span="4"
                  ><span class="dot">机构代收(司机收入)</span></el-col
                >
                <el-col :span="4">操作</el-col>
              </el-col>
              <el-col
                :span="24"
                v-for="(item, index) in form.zydList"
                :key="index"
                class="form-box-item-content"
              >
                <el-col :span="4" class="content-list">
                  {{ item.companyName }}
                </el-col>
                <el-col :span="4" class="content-list">
                  <el-form-item
                    :prop="'zydList.' + index + '.carrierInstitutionRatio'"
                    :rules="rules.carrierInstitutionRatio"
                    v-if="item.isEdit"
                  >
                    <el-input v-model="item.carrierInstitutionRatio">
                      <div slot="append">%</div>
                    </el-input>
                  </el-form-item>
                  <span v-else>{{ item.carrierInstitutionRatio }}%</span>
                </el-col>
                <el-col :span="4" class="content-list">
                  <el-form-item
                    :prop="'zydList.' + index + '.technologyFeeRatio'"
                    :rules="rules.technologyFeeRatio"
                    v-if="item.isEdit"
                  >
                    <el-input v-model="item.technologyFeeRatio">
                      <div slot="append">%</div>
                    </el-input>
                  </el-form-item>
                  <span v-else>{{ item.technologyFeeRatio }}%</span></el-col
                >
                <el-col :span="4" class="content-list"
                  ><el-form-item
                    :prop="'zydList.' + index + '.deposit'"
                    :rules="rules.deposit"
                    v-if="item.isEdit"
                  >
                    <el-input v-model="item.deposit">
                      <div slot="append">元</div>
                    </el-input>
                  </el-form-item>
                  <span v-else>{{ item.deposit }}元</span>
                </el-col>
                <el-col :span="4" class="content-list">
                  <el-form-item
                    :prop="'zydList.' + index + '.companyAgency'"
                    :rules="rules.companyAgency"
                    v-if="item.isEdit"
                  >
                    <el-input v-model="item.companyAgency">
                      <div slot="append">%</div>
                    </el-input>
                  </el-form-item>
                  <span v-else>{{ item.companyAgency }}%</span>
                </el-col>
                <el-col :span="4" class="content-list">
                  <template v-if="item.isEdit">
                    <el-button type="text" @click="handleCancel1(item, index)"
                      >取消</el-button
                    >
                    <el-button type="text" @click="handleSave1(item, index)"
                      >保存</el-button
                    >
                  </template>
                  <template v-else>
                    <el-button type="text" @click="handleEdit1(item, index)"
                      >编辑</el-button
                    >
                  </template>
                </el-col>
              </el-col>
            </el-form>
          </el-row>
        </div>
        <div class="config-list">
          <div class="config-list-title">
            <div class="config-list-title-txt">
              <span>三方订单分佣规则设置</span>
              <span
                >拼满运平台技术服务费是按三方订单运费进行比例计算，若YMM的技术服务费占比高于分佣临界点时，则对应订单不增加拼满运的服务费</span
              >
            </div>
            <div class="config-list-title-btns">
              <template v-if="isEdit2">
                <el-button type="text" @click="isEdit2 = false">取消</el-button>
                <el-button type="text" @click="handleSave2()">保存</el-button>
              </template>
              <template v-else>
                <el-button type="text" @click="isEdit2 = true">编辑</el-button>
              </template>
            </div>
          </div>
          <el-row :gutter="20" class="form-box">
            <el-form
              ref="form2"
              :model="form"
              :rules="rules"
              label-position="top"
            >
              <el-col :span="8">
                <el-form-item label="YMM分佣临界点：" prop="lx.ymmCritical">
                  <el-input
                    :disabled="!isEdit2"
                    clearable
                    placeholder="请输入"
                    v-model="form.lx.ymmCritical"
                  >
                    <div slot="append">%</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="拼满运增加占比：" prop="lx.zydProportion">
                  <el-input
                    :disabled="!isEdit2"
                    clearable
                    placeholder="请输入"
                    v-model="form.lx.zydProportion"
                    ><div slot="append">%</div></el-input
                  >
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>

        <div class="config-list">
          <div class="config-list-title">
            <div class="config-list-title-txt">
              <span> 销售渠道（机构）返佣规则设置</span>
              <span
                >销售渠道返佣比例按订单总额（不含发票金额）计算，并自动从拼满运抽成中进行扣除，因此销售返佣抽成比例应≤于拼满运抽成比例</span
              >
            </div>
            <!--            <div class="config-list-title-btns">-->
            <!--              <template v-if="isEdit2">-->
            <!--                <el-button type="text" @click="isEdit2 = false"-->
            <!--                  >取消</el-button-->
            <!--                >-->
            <!--                <el-button type="text" @click="handleSave2()"-->
            <!--                  >保存</el-button-->
            <!--                >-->
            <!--              </template>-->
            <!--              <template v-else>-->
            <!--                <el-button type="text" @click="isEdit2 = true"-->
            <!--                  >编辑</el-button-->
            <!--                >-->
            <!--              </template>-->
            <!--            </div>-->
          </div>

          <el-row :gutter="10" class="form-box1">
            <el-form
              ref="form3"
              :model="form"
              :rules="rules"
              label-position="top"
            >
              <el-col :span="24" class="form-box-item-title">
                <el-col :span="5">
                  <span>机构名称</span>
                </el-col>
                <el-col :span="5"
                  ><span class="dot">机构分佣首单抽成</span></el-col
                >
                <el-col :span="5"
                  ><span class="dot">机构分佣非首单抽成</span></el-col
                >
                <el-col :span="5"
                  ><span class="dot">机构推广分佣上限</span></el-col
                >
                <el-col :span="4">操作</el-col>
              </el-col>
              <el-col
                :span="24"
                v-for="(item, index) in form.rebateCompanies"
                :key="index"
                class="form-box-item-content"
              >
                <el-col :span="5" class="content-list">
                  <!--                  {{ getLocalLabel("companyType", item.companyType) }}-->
                  {{ item.companyName }}
                </el-col>
                <el-col :span="5" class="content-list">
                  <el-form-item
                    :prop="'rebateCompanies.' + index + '.firstOrderCommission'"
                    :rules="rules.firstOrderCommission"
                    v-if="item.isEdit"
                  >
                    <el-input v-model="item.firstOrderCommission">
                      <div slot="append">%</div>
                    </el-input>
                  </el-form-item>
                  <span v-else>{{ item.firstOrderCommission }}%</span>
                </el-col>
                <el-col :span="5" class="content-list">
                  <el-form-item
                    :prop="'rebateCompanies.' + index + '.otherCommission'"
                    :rules="rules.otherCommission"
                    v-if="item.isEdit"
                  >
                    <el-input v-model="item.otherCommission">
                      <div slot="append">%</div>
                    </el-input>
                  </el-form-item>
                  <span v-else>{{ item.otherCommission }}%</span></el-col
                >
                <el-col :span="5" class="content-list"
                  ><el-form-item prop="promotionUpper" v-if="item.isEdit">
                    <el-input v-model="item.promotionUpper">
                      <div slot="append">元</div>
                    </el-input>
                  </el-form-item>
                  <span v-else>{{ item.promotionUpper }}元</span>
                </el-col>
                <el-col :span="4" class="content-list">
                  <template v-if="item.isEdit">
                    <el-button type="text" @click="item.isEdit = false"
                      >取消</el-button
                    >
                    <el-button type="text" @click="handleSave3(item, index)"
                      >保存</el-button
                    >
                  </template>
                  <template v-else>
                    <el-button type="text" @click="item.isEdit = true"
                      >编辑</el-button
                    >
                  </template>
                </el-col>
              </el-col>
            </el-form>
          </el-row>
        </div>

        <div class="config-list">
          <div class="config-list-title">
            <div class="config-list-title-txt">
              <span>销售渠道（司机）返佣规则设置</span>
              <span
                >销售渠道返佣比例按订单总额（不含发票金额）计算，并自动从拼满运抽成中进行扣除，因此销售返佣抽成比例应≤于拼满运抽成比例</span
              >
            </div>
            <div class="config-list-title-btns">
              <template v-if="isEdit4">
                <el-button type="text" @click="isEdit4 = false">取消</el-button>
                <el-button type="text" @click="handleSave4()">保存</el-button>
              </template>
              <template v-else>
                <el-button type="text" @click="isEdit4 = true">编辑</el-button>
              </template>
            </div>
          </div>
          <el-row :gutter="20" class="form-box">
            <el-form
              ref="form4"
              :model="form"
              :rules="rules"
              label-position="top"
            >
              <el-col :span="8">
                <el-form-item
                  label="司机分佣首单抽成："
                  prop="rebateDriver.firstOrderCommission"
                >
                  <el-input
                    :disabled="!isEdit4"
                    clearable
                    placeholder="请输入"
                    v-model="form.rebateDriver.firstOrderCommission"
                  >
                    <div slot="append">%</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="司机分佣非首单抽成："
                  prop="rebateDriver.otherCommission"
                >
                  <el-input
                    :disabled="!isEdit4"
                    clearable
                    placeholder="请输入"
                    v-model="form.rebateDriver.otherCommission"
                    ><div slot="append">%</div></el-input
                  >
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="司机推广单货主分佣上限："
                  prop="rebateDriver.promotionUpper"
                >
                  <el-input
                    :disabled="!isEdit4"
                    clearable
                    placeholder="请输入"
                    v-model="form.rebateDriver.promotionUpper"
                    ><div slot="append">%</div></el-input
                  >
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import {
  getJDConfig,
  getPage,
  setLxConfig,
  setRebateCompanyConfig,
  setRebateDriverConfig,
  setZydConfig,
} from "./api";
import { validatePrice } from "@/utils/validate";
import { getLocalLabel } from "../../../utils/localDict";
export default {
  name: "commission-sharing-rule-config",
  components: {
    OperateBox,
    CustomTable,
    addOrEdit,
  },
  data() {
    return {
      searchForm: {
        shareStageId: "",
      },
      dispatchDeptData: [],
      selectDispatch: "",
      form: {
        zydList: [],
        lx: {
          ymmCritical: "",
          zydProportion: "",
        },
        rebateCompanies: [],
        rebateDriver: {
          firstOrderCommission: "",
          otherCommission: "",
          promotionUpper: "",
        },
      },
      isEdit2: false,
      isEdit4: false,
      loading: false,
      rules: {
        companyAgency: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        deposit: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        technologyFeeRatio: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        carrierInstitutionRatio: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        firstOrderCommission: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        otherCommission: [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        "lx.ymmCritical": [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        "lx.zydProportion": [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        "rebateDriver.otherCommission": [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        "rebateDriver.promotionUpper": [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
        "rebateDriver.firstOrderCommission": [
          { required: true, message: "不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getLeftPage();
  },
  mounted() {},
  methods: {
    getLocalLabel,
    getLeftPage() {
      getPage().then((res) => {
        if (res.code === 200) {
          this.dispatchDeptData = res.data;

          if (this.dispatchDeptData.length > 0) {
            this.checkDispatch(this.dispatchDeptData[0]);
          }
        }
      });
    },
    checkDispatch(item) {
      if (this.searchForm.shareStageId === item.shareStageId) {
        return;
      }
      this.searchForm.shareStageId = item.shareStageId;
      this.getConfig(this.searchForm.shareStageId);
    },
    handleCancel1(item, index) {
      this.form.zydList[index].isEdit = false;
    },
    handleEdit1(item, index) {
      this.form.zydList[index].isEdit = true;
    },

    handleSave1(item, index) {
      this.$refs.form1.validate((valid) => {
        if (valid) {
          this.setZydConfigData(item, index);
          // this.form.box1[index].isEdit = false;
        } else {
          return false;
        }
      });
    },
    getConfig(shareStageId) {
      this.loading = true;
      getJDConfig(shareStageId)
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            if (res.data.zydList && res.data.zydList.length > 0) {
              res.data.zydList.forEach((item) => {
                item.isEdit = false;
              });
            }
            if (
              res.data.rebateCompanies &&
              res.data.rebateCompanies.length > 0
            ) {
              res.data.rebateCompanies.forEach((item) => {
                item.isEdit = false;
              });
            }
            this.form = res.data;
            // this.form.lx.ymmCritical = res.data?.lx?.ymmCritical;
            // this.form.lx.zydProportion = res.data?.lx?.zydProportion;
            // this.form.rebateDriver.firstOrderCommission =
            //   res.data?.rebateDriver?.firstOrderCommission;
            // this.form.rebateDriver.otherCommission =
            //   res.data?.rebateDriver?.otherCommission;
            // this.form.rebateDriver.promotionUpper =
            //   res.data?.rebateDriver?.promotionUpper;
            // this.form.zydList = res.data.zydList;
            // this.form.rebateCompanies = res.data.rebateCompanies;
            // this.$refs.form2.resetFields();
            // this.$refs.form4.resetFields();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSave2() {
      // this.isEdit2 = false;
      this.$refs.form2.validate((valid) => {
        if (valid) {
          this.setLxConfigData();
          // this.form.box1[index].isEdit = false;
        } else {
          return false;
        }
      });
    },
    handleSave3(item, index) {
      this.$refs.form3.validate((valid) => {
        if (valid) {
          this.setRebateCompanyConfigData(item, index);
          // this.form.box1[index].isEdit = false;
        } else {
          return false;
        }
      });
    },
    handleSave4() {
      // this.isEdit4 = false;
      this.$refs.form4.validate((valid) => {
        if (valid) {
          this.setRebateDriverConfigData();
          // this.form.box1[index].isEdit = false;
        } else {
          return false;
        }
      });
    },
    setZydConfigData(item, index) {
      setZydConfig(item).then((res) => {
        if (res.code === 200) {
          this.form.zydList[index].isEdit = false;
          this.$message.success("保存成功");
        }
      });
    },
    setLxConfigData() {
      setLxConfig({
        shareLxId: this.form.lx.shareLxId,
        ymmCritical: this.form.lx.ymmCritical,
        zydProportion: this.form.lx.zydProportion,
      }).then((res) => {
        if (res.code === 200) {
          this.isEdit2 = false;
          this.$message.success("保存成功");
        }
      });
    },
    setRebateCompanyConfigData(item, index) {
      setRebateCompanyConfig(item).then((res) => {
        if (res.code === 200) {
          this.form.rebateCompanies[index].isEdit = false;
          this.$message.success("保存成功");
        }
      });
    },
    setRebateDriverConfigData() {
      setRebateDriverConfig({
        firstOrderCommission: this.form.rebateDriver.firstOrderCommission,
        otherCommission: this.form.rebateDriver.otherCommission,
        promotionUpper: this.form.rebateDriver.promotionUpper,
        shareRebateId: this.form.rebateDriver.shareRebateId,
      }).then((res) => {
        if (res.code === 200) {
          this.isEdit4 = false;
          this.$message.success("保存成功");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.commission-sharing-rule-config {
  display: flex;
  flex-direction: row;
  .left-box {
    width: 20%;
    height: 100%;
    //background-color: #ffffff;
    flex-shrink: 0;
    padding: 0.2rem 0 0.2rem 0.2rem;
    box-sizing: border-box;
    .left-content {
      width: 100%;
      height: 100%;
      background-color: #ffffff;
      border-radius: 0.08rem;
      padding: 0.2rem;
      box-sizing: border-box;
      overflow-y: auto;
      .list {
        width: 100%;
        height: 0.4rem;
        color: #434343;
        display: flex;
        align-items: center;
        padding-left: 0.1rem;
        box-sizing: border-box;
        font-size: 0.16rem;
        cursor: pointer;
        border-radius: 0.04rem;
      }
      .select-dispatch {
        background: rgba(18, 105, 255, 0.05);
        color: #1269ff;
        position: relative;
        &:before {
          position: absolute;
          left: 0;
          top: 0;
          content: "";
          width: 0.02rem;
          height: 100%;
          background-color: #1269ff;
        }
      }
    }
  }
  .right-box {
    flex: 1;
    padding: 0.2rem;
    box-sizing: border-box;

    .right-content {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #ffffff;
      border-radius: 0.08rem;
      padding: 0.1rem;
      box-sizing: border-box;
      .config-list {
        border-bottom: 0.01rem solid #dce5f5;
        padding-bottom: 0.1rem;
        margin-bottom: 0.1rem;
      }
      .config-list:nth-last-of-type(1) {
        border-bottom: none;
      }
    }
    .config-list-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 0.1rem;
      .config-list-title-txt {
        span:nth-of-type(1) {
          color: #000000;
          font-size: 0.16rem;
        }
        span:nth-of-type(2) {
          color: #8c8c8c;
          font-size: 0.12rem;
          padding-left: 0.1rem;
        }
      }
      .config-list-title-btns {
      }
    }
  }
  .form-box1 {
    padding: 0.1rem 0.1rem 0.2rem;
    .form-box-item-title {
      background: #f0f5ff;
      height: 0.32rem;
      display: flex;
      align-items: center;
      color: #000000;
      font-size: 0.14rem;
      .dot {
        position: relative;
        &:before {
          position: absolute;
          content: "*";
          color: red;
          left: -0.1rem;
          top: 0.04rem;
        }
      }
    }
    .form-box-item-content {
      display: flex;
      align-items: center;
      width: 100%;
      height: 0.5rem;
      .content-list {
        display: flex;
        align-items: center;
        height: 100%;
        width: 100%;
        ::v-deep .el-form-item {
          margin-bottom: 0;
        }
      }
    }
    .form-box-item-content:nth-of-type(2n-1) {
      background: #fbfcff;
    }
  }
}
</style>
